/**
 * Central support contact for end users.
 * Used by Help/Contact buttons across the app, public footer, and any
 * future in-app support entry points. Keep in sync with PublicFooter
 * mailto and Reply-To addresses configured for transactional email.
 */
export const SUPPORT_EMAIL = "hello@relark.dk";

/**
 * Build a mailto: href with an optional pre-filled subject.
 * Subject is encoded so it works across all email clients.
 */
export function supportMailto(subject?: string): string {
  if (!subject) return `mailto:${SUPPORT_EMAIL}`;
  return `mailto:${SUPPORT_EMAIL}?subject=${encodeURIComponent(subject)}`;
}
